// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___D4W8","delete":"styles_delete__3iXZo","update":"styles_update__FQThW","add":"styles_add__HUdCT"};